'use client'

import { useState } from 'react'
import ImageWithPlaceholder from './ImageWithPlaceholder'

interface ImageGalleryProps {
  images: string[]
  mainImage?: string | null
  className?: string
}

export default function ImageGallery({
  images,
  mainImage,
  className = '',
}: ImageGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  
  // Ana resmi ilk sıraya ekle
  const allImages = mainImage 
    ? [mainImage, ...images.filter(img => img !== mainImage)]
    : images

  if (allImages.length === 0) {
    return (
      <div className={`${className}`}>
        <ImageWithPlaceholder
          src={null}
          alt="Resim yok"
          width={800}
          height={600}
          className="w-full h-auto rounded-2xl"
        />
      </div>
    )
  }

  return (
    <div className={`${className}`}>
      {/* Ana resim gösterimi */}
      <div className="mb-4">
        <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-gray-100">
          <ImageWithPlaceholder
            src={allImages[selectedIndex]}
            alt={`Galeri resmi ${selectedIndex + 1}`}
            fill
            objectFit="cover"
            className="rounded-2xl"
          />
        </div>
      </div>

      {/* Thumbnail galeri */}
      {allImages.length > 1 && (
        <div className="grid grid-cols-4 md:grid-cols-6 gap-2">
          {allImages.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`relative aspect-square overflow-hidden rounded-2xl border-2 transition-all ${
                selectedIndex === index
                  ? 'border-primary-500 ring-2 ring-primary-200'
                  : 'border-gray-200 hover:border-primary-300'
              }`}
            >
              <ImageWithPlaceholder
                src={image?.replace('/uploads/images/', '/uploads/thumbnails/') || image}
                alt={`Thumbnail ${index + 1}`}
                fill
                objectFit="cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

